<template>
  <div class="log">
    <basic-container>
      <avue-crud ref="crud"
                 :page.sync="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 v-model="form"
                 @on-load="getList"
                 @search-change="searchChange"
                 :search.sync="search"
                 @search-reset="searchRest"
                 @refresh-change="refreshChange"
                 @row-update="update"
                 @row-save="handleSave"
                 @size-change="sizeChange"
                 @current-change="currentChange">
        <template slot="menuLeft" slot-scope="{size}">
          <el-button type="primary" @click="$refs.crud.rowAdd()" :size="size" icon="el-icon-plus">新增引擎</el-button>
        </template>
        <template slot-scope="{disabled,size}" slot="priceSearch">
          <div style="display: flex">
            <el-input type="number" :min="0.00" :step="0.01" size="small" oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}"
                      v-model="search.minPrice"></el-input>
            <i class="el-icon-minus" style="padding-top: 7px;"></i>
            <el-input type="number" :min="0.00" :step="0.01" size="small" oninput="if(isNaN(this.value)) { this.value = null } if(this.value.indexOf('.')>0){this.value=this.value.slice(0,this.value.indexOf('.')+3)} if(this.value.indexOf('.')<0 && this.value>99.99) {this.value=this.value.slice(0,2)}"
                      v-model="search.maxPrice"></el-input>
          </div>
        </template>
        <template slot-scope="{disabled,size}" slot="nameSearch">
          <el-input  v-model="search.keywords" clearable></el-input>
        </template>
        <template slot-scope="scope" slot="status">
            <avue-switch inactive-color="#13ce66" active-color="#ff4949"
                       v-model="scope.row.status" @click="markingStatusChange(scope.row)" :dic="dic"></avue-switch>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button v-if="engine_edit" icon="el-icon-edit" size="small" type="text"
                     @click="handleRowClick(scope.row,scope.index)">修改</el-button>
          <el-button v-if="engine_sync2" size="small" type="text" :disabled="scope.row.sync2 === 1"
          @click="handleBackup(scope.row,'woordee')">{{scope.row.sync2 === 0?'同步新语翼':'已同步新语翼'}}</el-button>
          <el-button v-if="engine_sync1" size="small" type="text" :disabled="scope.row.sync1 === 1"
          @click="handleBackup(scope.row,'pm')">{{scope.row.sync1 === 0?'同步PM端':'已同步PM端'}}</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { getPageEngine, statusEngine, saveEngine, syncEngine, updateEngine } from '@/api/engine/list'
import {statistics} from '@/api/dot/flow'
import {tableOption} from '@/const/crud/engine/list'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'log',
  data() {
    return {
      hideFlag:null,
      prohibitFlag:null,
      form: {},
      tempForm: {},
      dialogFormVisible: false, //表格显示隐藏
      dialogFormStatus: false, //表格显示隐藏
      logTableLoading: false,
      statusSubmitFlag: false,//打标权限、打标审核权限、PE权限、PE审核权限是否点击提交标识
      search:{
        keywords:null,
        minPrice:null,
        maxPrice:null
      },
      logId:"",
      dic:[{
        label:'启用',
        value:1
      },{
        label:'禁用',
        value:0
      }],
      credibility:'',
      tableData: [],
      logListData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      logPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      tableLoading: false,
      statusObj: {},
      idList:[],
      tableOption: tableOption,
      staParams: null,
      industryOptions: [],
    }
  },
  computed: {
    ...mapGetters(['permissions','userInfo']),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  beforeRouteEnter(to, from, next) {
		next(vm=>{
			vm.curPath = to.path;
			vm.oldPath = from.path;
		})
	},
  created() {
    this.engine_add = this.permissions["engine_add"];
    this.engine_edit = this.permissions["engine_edit"];
    this.engine_sync1 = this.permissions["engine_sync1"];
    this.engine_sync2 = this.permissions["engine_sync2"];
  },
  mounted() {
    this.staParams = {
			u_id: this.userInfo.staffId,
			time: new Date().getTime(),
			browser: navigator.userAgent.toLowerCase(),
			url: document.URL,
			scene_name: '引擎管理'
		}
    this.statistics();
  },
  methods: {
    statistics() {
			statistics(Object.assign({
				event_type: 'view',
				ref_url: this.oldPath,
			}, this.staParams))
		},

    handleBackup(row,client) {
      syncEngine({
        id: row.id,
        client: client,
        username: this.userInfo.username
        }).then(res=>{
          if (res.data.data === 1) {
            if (client === 'woordee') {
              row.sync2 = 1;
            } else {
              row.sync1 = 1;
            }
            this.$message.success('同步成功');
          } else {
            this.$message.error("同步失败,请重新操作");
          }
      })
      statistics(Object.assign({
        event_name: '同步新语翼/同步PM端',
        event_type: 'click',
        class_name: 'syncEngine',
        class_url: '/dotadmin/engine/syncEngine',
        event_params: '{id: row.id, client: client, username: this.userInfo.username}'
      }, this.staParams))
    },
    handleRowClick(row,index) {
      this.$refs.crud.rowEdit(row,index);
    },
    handleSave(row, done) {
      saveEngine(Object.assign(row,{
        username: this.userInfo.username
      })).then(res => {
        if (res.data.data>0) {
          this.$message.success("新增引擎成功")
          this.refreshChange()
          done()
        } else {
          this.$message.error("新增引擎失败".msg)
          done()
        }
      })
      statistics(Object.assign({
        event_name: '新增引擎',
        event_type: 'click',
        class_name: 'saveEngine',
        class_url: '/dotadmin/engine/saveEngine',
        event_params: "Object.assign(row,{username: this.userInfo.username })"
      }, this.staParams))
    },
    // 译员清空有问题
    searchRest(form) {
      this.search.id = '';
    },
    markingStatusChange(data) {
      statusEngine({
        id:data.id,
        status:data.status,
        username: this.userInfo.username
      }).then(res=>{
        if (res.data.data > 0) {
          this.$message.success("引擎状态改变成功");
          this.getList(this.page);
        } else {
          this.$message.error("引擎状态改变失败");
        }
      })
    },
    getList(page, params) {
      console.log(this.tempForm)
      this.tableLoading = true
      getPageEngine(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
      }, this.tempForm)).then(response => {
        let records = response.data.data.records;
        records.forEach(item => item.backup = true);
        this.tableData = records;
        this.page.total = response.data.data.total
        this.tableLoading = false
      })
    },
    searchChange(form, done) {
      this.tempForm = form;
      this.page.currentPage = 1;//避免翻页了再搜索为空的情况，明明应该有数据
      this.getList(this.page, form)
      done()
      statistics(Object.assign({
        event_name: '搜索',
        event_type: 'click',
      }, this.staParams))
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    currentChange(current) {
      this.page.currentPage = current
    },
    logSizeChange(pageSize) {
      this.logPage.pageSize = pageSize
    },
    logCurrentChange(current) {
      this.logPage.currentPage = current
    },
    refreshChange() {
      this.getList(this.page)
    },
    update(row, index, done, loading) {
      updateEngine(Object.assign(this.form, {username: this.userInfo.username})).then(() => {
        this.getList(this.page,this.tempForm);
        done();
        this.$message.success('修改成功')
      }).catch(() => {
        loading();
      });
      statistics(Object.assign({
        event_name: '修改',
        event_type: 'click',
        class_name: 'updateEngine',
        class_url: '/dotadmin/engine/updateEngine',
        event_params: "Object.assign(this.form, {username: this.userInfo.username})"
      }, this.staParams))
    },
  },
  
}
</script>
<style scoped>
.item {
  margin-top: 10px;
  margin-right: 25px;
}
</style>
